// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__3_HE6","content":"section_content__GVZRv","files":"section_files__2b5pS","links":"section_links__3v2Kw"};